export default __webpack_public_path__ + "static/media/diamond-clarity-2@2x.73136399.png";